import axios from 'axios';

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true, timeout: 20000 });
let refreshPromise;
api.interceptors.response.use(r => r, async error => {
  const config = error.config;
  if (error.response?.status === 401 && !config._retry && !config.url.includes('/auth/login') && !config.url.includes('/auth/refresh') && !config.url.includes('/auth/logout')) {
    config._retry = true;
    try {
      if (!refreshPromise) refreshPromise = api.post('/auth/refresh').finally(() => { refreshPromise = null; });
      await refreshPromise;
      return api(config);
    } catch (_) { /* Return original sign-in error. */ }
  }
  return Promise.reject(error);
});

export const errorMessage = (error) => {
  const detail = error.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(x => `${x.loc?.slice(1).join(' ') || 'Form'}: ${x.msg}`).join(' ');
  return 'We couldn’t connect. Your details are still here. Please try again.';
};